angular.module('services.utility.LTIService', [])

/**
 * The LTIService provides functions interacting with LTI endpoints
 *
 * @class LTIService
 * @constructor
 * @module services.utility.LTIService
 */
.factory('LTIService', [
  '$http',
  'GLOBAL',
  'ApiService',
  function ($http, GLOBAL, ApiService) {
    'use strict';

    var service = {

      getSignedPayload: function (params) {
        var request = {
          method: 'GET',
          url: GLOBAL.apiPath + '/lti/signed-launch-payload',
          headers: ApiService.config.headers,
          params: params
        };

        return $http(request);
      }

    };

    return service;
  }
]);
